<!--
    description： 组织架构 - 组织管理 - 添加部门
-->
<template>
  <IviewModal
    v-bind="$attrs"
    @on-cancel="$emit('input', false)"
    @on-ok="save"
    size="middle"
    class="iviewModal"
  >
    <div class="form_container">
      <Form ref="form_container" :model="form" :rules="ruleValidate">
        <FormItem :label="'所属组织'">
          <IviewInput v-model="form.organ" disabled></IviewInput>
        </FormItem>
        <!-- <FormItem prop="upDep" :label="'上级部门'" required> -->
        <FormItem label='上级部门'>
          <IviewTreeSelect :disabled="$parent.ppType !== 'add'" v-model="form.upDep" :data="config.depTree"></IviewTreeSelect>
        </FormItem>
        <FormItem prop="title" :label="'部门名称'" required>
          <IviewInput v-model="form.title"></IviewInput>
        </FormItem>

      </Form>
    </div>
  </IviewModal>
</template>

<script>
export default {
  name: "addCompay",
  inject:['config'],
  props: {
    form:{
      type:Object,
      default:()=>({})
    }
  },
  data() {
    return {
      ruleValidate: {
        title: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {},
  created() {},
  methods: {
    save() {
      this.$refs["form_container"].validate(async (valid) => {
        if (valid) {
          this.$emit("confirm", this.form);
          // this.$Spin.hide();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.iviewModal {
  .form_container {
    height: 100%;

    /deep/.ivu-form {
      height: 100% !important;
    }
  }
}
</style>